import { useState } from "react";
import "./Signup.css"
import { BiHide } from "react-icons/bi";
import { FaEye } from "react-icons/fa";
import { CiFacebook } from "react-icons/ci";
import { CiTwitter } from "react-icons/ci";
import { FaGoogle } from "react-icons/fa6";
import { showToast } from "../../utils/customToast";

import { Link, useNavigate } from "react-router-dom";
function Signup() {
  const navigate = useNavigate();
  const [name, setname] = useState("");
  const [email, setEmail] = useState("");
  const [number, setnumber] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const onsubmitvalue = async (e) => {
    e.preventDefault();
    if (loading) return;

    const data = { name, email, number, password };
    try {
      setLoading(true);
      const res = await fetch("/api/auth/signup", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });
      const result = await res.json();
      if (result.success) {
        showToast.save("Account created successfully!");
        setTimeout(() => navigate("/"), 1200);
      } else {
        showToast.error(result.message || "Signup failed");
      }
    } catch (error) {
      showToast.error("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="sign_up-container">
        <div className="signup_div">
          <div className="sign_logo">
            <img src="./media/responseinfoway_logo.jpg" alt="errir image" />
          </div>
          <form className="lognup_page" onSubmit={onsubmitvalue}>
            <h6>Create New Account !</h6>
            <p>Get your free Invoika account now</p>

            <label className="form-label">Name</label>
            <input type="text" className="form-control" placeholder="Enter Full Name"
              value={name}
              onChange={(e) => setname(e.target.value)}
            />

            <label className="form-label">Email</label>
            <input type="email" className="form-control" placeholder="Enter Email ID"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <label className="form-label">Mobile Number</label>
            <input type="number" className="form-control no-spinner" placeholder="Mobile Number"
              value={number}
              onChange={(e) => setnumber(e.target.value)}
            />


            <label className="form-label">Password:</label>
            <input
              className="form-control"
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"

            />

            <div className="heide_show-signup" onClick={togglePasswordVisibility}>
              {showPassword ? <i><BiHide /></i> : <i> <FaEye /></i>}
            </div>

            <div className="rember_forgatepassup mt-3"><p>By registering you agree to the Invoika</p><Link to={"/home"}>  <h6> Terms of Use</h6></Link></div>


            <button type="submit" className="btn btn" id="login_btn" disabled={loading}>
              {loading ? "Signing Up..." : "Sign Up"}
            </button>

            <div className="hrsign-in"><hr className="signin-other-title" /> Create account with</div>

            <div className="socalmedia_icons">
              <i className="facbook_i"> <CiFacebook /></i>
              <i className="twitter_i"><CiTwitter /></i>
              <i className="google_i"><FaGoogle /></i>
            </div>

            <div className="Don_have">Don't have an account ? <Link to={"/"}><p>Signin</p></Link></div>



          </form>


        </div>

      </div>
    </>
  );
}

export default Signup; 